import React, {Component} from 'react';
import {Button, Form, Grid, Header, Icon, Image, Modal, Popup, Segment, Message} from 'semantic-ui-react';
import * as AlarmPlaceholder from "../../assets/placeholderImage.png";
import ReportContainer from "../../containers/report_container";
import AddNewAlarm from './add_new_alarm';
import {uploadAlarmDetails} from "../../data/report_api";
import Loader from "../universal/loader";
import ImageUploadDropzone from './image_upload_dropzone';

const uuidv1 = require('uuid/v1');

class Alarms extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showAlarmsSection: false,
            DataURL: undefined,
            ciImageEdit: undefined,
            coImageEdit: undefined,
            images: [],
            showEdit: undefined,
            showCoEdit: undefined,
            alarmLocation: undefined,
            alarmName: undefined,
            alarmDesc: undefined,
            alarmExpiry:undefined,
            inspectionType: undefined,
            showNameEdit: undefined,
            showCoNameEdit: undefined,
            errorMsg:undefined,
            imgErrorMsg:undefined,
            failedUploads:[]
        }
    }

    componentWillMount() {
        this.setState({
            showAlarmsSection: this.props.showAlarms,
            inspectionType: this.props.reportDetails['inspection_type']
        });
    }


    updateAlarmLocation = (alarmDetail) => {
        if (!alarmDetail.action) {
            alarmDetail['action'] = 'update'
        }
        if (this.state.inspectionType !== 'co') {
            alarmDetail['ci_location'] = this.state.alarmLocation;

        }
        else {
            alarmDetail['co_location'] = this.state.alarmLocation;
        }
        this.props.updateAlarmInReport(alarmDetail);
    };

    updateAlarmName = (alarmDetail) => {
        if (!alarmDetail.action) {
            alarmDetail['action'] = 'update'
        }
        alarmDetail['name'] = this.state.alarmName;

        this.props.updateAlarmInReport(alarmDetail);
    };

    updateAlarmDescription = (alarmDetail) => {
        if (!alarmDetail.action) {
            alarmDetail['action'] = 'update'
        }
        if (this.state.inspectionType !== 'co') {
            alarmDetail['ci_description'] = this.state.alarmDesc;

        }
        else {
            alarmDetail['co_description'] = this.state.alarmDesc;
        }
        this.props.updateAlarmInReport(alarmDetail);
    };

    updateAlarmExpiry = (alarmDetail) => {
        if (!alarmDetail.action) {
            alarmDetail['action'] = 'update'
        }
        if (this.state.inspectionType !== 'co') {
            alarmDetail['ci_expiry'] = this.state.alarmExpiry;

        }
        else {
            alarmDetail['co_expiry'] = this.state.alarmExpiry;
        }
        this.props.updateAlarmInReport(alarmDetail);
    };

    uploadAlarms = () => {
        this.setState({isSaving:true,errorMsg:undefined});
        let reportUpdateAlarms = JSON.parse(JSON.stringify(this.props.updateAlarms));
        let reportUpdateAlarmsList = reportUpdateAlarms.alarms;
        let images = [];
        for (let i = 0; i < reportUpdateAlarmsList.length; i++) {
            if (reportUpdateAlarmsList[i]['ci_image']) {
                const ciImage = this.props.updateAlarms.alarms[i]['ci_image'];
                if (!ciImage['image_path']) {
                    images.push(ciImage);
                }
                reportUpdateAlarmsList[i]['ci_image'] = {id: reportUpdateAlarmsList[i]['ci_image']['id']}
            }
            if (reportUpdateAlarmsList[i]['co_image']) {
                const coImage = this.props.updateAlarms.alarms[i]['co_image'];
                if (!coImage['image_path']) {
                    images.push(coImage);
                }
                reportUpdateAlarmsList[i]['co_image'] = {id: reportUpdateAlarmsList[i]['co_image']['id']}
            }
        }
        reportUpdateAlarms.alarms = reportUpdateAlarmsList;
        if (reportUpdateAlarms.alarms.length > 0 || images.length > 0) {
            let reportType = this.props.reportDetails['inspection_type'];
            const reportTypes = reportType === 'co' ? "co" : "ci";

            uploadAlarmDetails(reportTypes, reportUpdateAlarms).then((response) => {
                if (response.success) {
                    if (images.length > 0) {
                        for (let i = 0; i < images.length; i++) {
                            const formData = new FormData();
                            formData.append("id", images[i].id);
                            formData.append("file", images[i].file);
                            if(i === images.length-1){
                                this.props.uploadImages(formData, this.completeCallBack);
                            }
                            else{
                                this.props.uploadImages(formData, this.successFn);
                            }
                        }
                    }
                    else {
                       this.completeCallBack(response);
                    }

                }
                else {
                    {this.setState({errorMsg:response.statusMessage || "There was an error while saving, please try again",isSaving:false})}
                }
            }).catch((e)=>{
                {this.setState({errorMsg:"There was an error while saving, please try again",isSaving:false})}
            });
        }
        else {
            this.exitWindow()
        }
    };

    updateAlarmImage = (file, alarmDetail) => {
        let fr = new FileReader();
        let image = "#";
        if (file) {
            fr.onload = (e) => {
                file['dataURL'] = e.target.result;
                image = {
                    id: uuidv1(),
                    file: file,
                    dataURL: e.target.result
                };
            };
            fr.readAsDataURL(file);
        }
        if (!alarmDetail.action) {
            alarmDetail['action'] = 'update'
        }
        if (this.state.inspectionType !== 'co') {
            setTimeout(() => {
                this.setState({images: image});
                alarmDetail['ci_image'] = this.state.images;
                this.props.updateAlarmInReport(alarmDetail);
                this.setState({ciImageEdit: undefined, coImageEdit: undefined})
            }, 1000);
        }
        else {
            setTimeout(() => {
                this.setState({images: image});
                alarmDetail['co_image'] = this.state.images;
                this.props.updateAlarmInReport(alarmDetail);
                this.setState({ciImageEdit: undefined, coImageEdit: undefined})
            }, 1000);
        }

    };

    successFn = (response, image) => {
        if (!response.success) {
            this.setState({failedUploads:[...this.state.failedUploads, image]})
        }
    };

    exitWindow = () =>{
        this.props.resetDataQueuedInAPI('alarms');
        this.setState({isSaving:false});
        this.props.handleClose();
    }

    completeCallBack = (response,image) => {

        if (response && !response.success && image) {
            let error = undefined
            let err = response.statusMessage
            if (err.response) {
                error = err.response.data.error || "An error occurred on the server.";
            } else if (err.request) {
                error = "Network error: Please check your internet connection.";
            } else {
                error = err.message || "An unknown error occurred.";
            }
            this.setState({failedUploads:[...this.state.failedUploads, image], isSaving:false, imgErrorMsg:error})
        } else {

            this.props.resetDataQueuedInAPI('alarms');
            this.setState({isSaving:false});
            this.props.handleClose();
        }
    };

    retryImageUpload = () =>{
        let images = [...this.state.failedUploads]
        this.setState({isSaving:true,imgErrorMsg:undefined,failedUploads:[]})
        if (images.length > 0) {
            for (let i = 0; i < images.length; i++) {
                if(i === images.length-1){
                    this.props.uploadImages(images[i], this.completeCallBack);
                }
                else {
                    this.props.uploadImages(images[i], this.successFn);
                }
            }
        }
        else {
            this.completeCallBack({success:true});
        }

    }

    deleteAlarm = (alarmObject) => {
        this.props.deleteAlarmInReport(alarmObject)
    };



    render() {
        const reportAlarms = this.props.reportDetails.alarms;
        const inspectionType = this.props.reportDetails['inspection_type'];
        return (<Segment>
            {this.state.isSaving && <Loader save={true}/>}
            <Modal open={this.state.showAlarmsSection} onClose={(e) => {
                this.uploadAlarms();
            }}>
                <Modal.Content style={{minHeight: '500px', overflowY: 'scroll'}}>
                    <Header size="large" floated="right"><Icon className="icon-button" name="save" onClick={(e) => {
                        this.uploadAlarms();
                    }}/></Header>
                    <Modal.Description>
                        <Header as='h2' textAlign='center'>
                            Alarms
                        </Header>
                         {this.state.errorMsg && <Message>There was an error while saving alarm details, please try again.   {this.state.errorMsg} <hr/>  <Button compact onClick={this.uploadAlarms}>Retry Save</Button> <Button compact onClick={this.exitWindow}>Exit Window</Button> </Message>}
                                                {this.state.failedUploads.length > 0 && <Message> {this.state.failedUploads.length} Image(s) failed to upload, try again? {this.state.imgErrorMsg}<hr/> <Button compact onClick={this.retryImageUpload}>Retry Upload</Button> <Button compact onClick={this.exitWindow}>Exit Window</Button> </Message>}
                        <Message><strong>IMPORTANT:</strong> Leave Expiry Data as Not Seen or type "Not Seen" if no Expiry Date found, do not use "NA" or "N/A"</Message>
                        {reportAlarms ? reportAlarms.map((alarm, i) => {
                            return (<Grid stackable key={alarm['client_id']}>
                                <Grid.Column width={8}>
                                    <Segment>
                                        <Header content="Check-In" color="teal" textAlign='center'/>
                                        <div ref={alarm['client_id']}>
                                            <Header textAlign="left">
                                                {this.state.showNameEdit === alarm['client_id'] &&
                                                <div className="ui input">
                                                    <Form onSubmit={() => {
                                                        this.updateAlarmName(alarm)
                                                    }}>
                                                        <input style={{verticalAlign: 'middle'}} type="text"
                                                               defaultValue={alarm['name']}
                                                               placeholder="Alarm Name"
                                                               onFocus={(e) => {
                                                                   this.setState({alarmName: e.target.value})
                                                               }}
                                                               onChange={(e) => {
                                                                   this.setState({alarmName: e.target.value})
                                                               }}
                                                               onBlur={() => {
                                                                   this.setState({showNameEdit: undefined});
                                                                   this.updateAlarmName(alarm);
                                                               }}
                                                               required
                                                        />
                                                    </Form>
                                                </div>
                                                }
                                                <div>
                                                    {this.state.showNameEdit !== alarm['client_id'] &&
                                                    <span onClick={(e) => {
                                                        if (inspectionType !== 'co') {
                                                            this.setState({showNameEdit: alarm['client_id']});
                                                        }
                                                    }}>{alarm['name']}</span>}
                                                    {inspectionType !== 'co' && <Popup
                                                        trigger={<Icon name="trash"
                                                                       className="pull-right icon-button info-grey"/>}
                                                        content={<Button negative content="Confirm Delete?"
                                                                         onClick={() => {
                                                                             this.deleteAlarm(alarm)
                                                                         }}/>}
                                                        on="click"
                                                        position="left center"
                                                        hideOnScroll
                                                    />}
                                                </div>
                                            </Header><Icon name="image" size="large" className="pull-right icon-button"
                                                           onClick={() => {
                                                               (inspectionType !== 'co') && this.setState({ciImageEdit: true})
                                                           }}/>
                                            <div>
                                                {this.state.ciImageEdit &&
                                                <ImageUploadDropzone handlerFunction={(file) => {
                                                    this.updateAlarmImage(file, alarm)
                                                }}/>}

                                                <Image width="100px" height="100px"
                                                       src={alarm['ci_image'] ? (alarm['ci_image']['image_path'] ? alarm['ci_image']['image_path'] : (alarm['ci_image']['file'] ? alarm['ci_image']['file']['dataURL'] : AlarmPlaceholder)) : AlarmPlaceholder}
                                                       centered rounded/>
                                            </div>
                                            <div>
                                                <dl>
                                                    <dt style={{minHeight: '50px'}}>Location</dt>
                                                    <dd style={{minHeight: '50px'}}>
                                                        {this.state.showEdit === alarm['client_id'] &&
                                                        <div className="ui input">
                                                            <Form onSubmit={() => {
                                                                this.updateAlarmLocation(alarm)
                                                            }}>
                                                                <input style={{verticalAlign: 'middle'}} type="text"
                                                                       defaultValue={alarm['ci_location']}
                                                                       placeholder="Alarm Location"
                                                                       onFocus={(e) => {
                                                                           this.setState({alarmLocation: e.target.value})
                                                                       }}
                                                                       onChange={(e) => {
                                                                           this.setState({alarmLocation: e.target.value})
                                                                       }}
                                                                       onBlur={() => {
                                                                           this.setState({showEdit: undefined});
                                                                           this.updateAlarmLocation(alarm);
                                                                       }}
                                                                       required
                                                                />
                                                            </Form>
                                                        </div>
                                                        }
                                                        {this.state.showEdit !== alarm['client_id'] &&
                                                        <span onClick={(e) => {
                                                            if (inspectionType !== 'co') {
                                                                this.setState({showEdit: alarm['client_id']});
                                                            }
                                                        }}>{alarm['ci_location'] ? alarm['ci_location'] : "NA"}</span>}
                                                    </dd>
                                                    <dt style={{minHeight: '50px'}}>Expiry Date</dt>
                                                    <dd style={{minHeight: '50px'}}>
                                                        {this.state.showEdit === alarm['client_id'] &&
                                                        <div className="ui input">
                                                            <Form onSubmit={() => {
                                                                this.updateAlarmExpiry(alarm)
                                                            }}>
                                                                <input style={{verticalAlign: 'middle'}} type="text"
                                                                       defaultValue={alarm['ci_expiry']}
                                                                       placeholder="Alarm Expiry Date"
                                                                       onFocus={(e) => {
                                                                           this.setState({alarmExpiry: e.target.value})
                                                                       }}
                                                                       onChange={(e) => {
                                                                           this.setState({alarmExpiry: e.target.value})
                                                                       }}
                                                                       onBlur={() => {
                                                                           this.setState({showEdit: undefined});
                                                                           this.updateAlarmExpiry(alarm);
                                                                       }}
                                                                       required
                                                                />
                                                            </Form>
                                                        </div>
                                                        }
                                                        {this.state.showEdit !== alarm['client_id'] &&
                                                        <span onClick={(e) => {
                                                            if (inspectionType !== 'co') {
                                                                this.setState({showEdit: alarm['client_id']});
                                                            }
                                                        }}>{alarm['ci_expiry'] ? alarm['ci_expiry'] : "Not Seen"}</span>}
                                                    </dd>
                                                    <dt style={{minHeight: '75px'}}>Description</dt>
                                                    <dd style={{minHeight: '75px'}} className="alarm-description">
                                                        {this.state.showEdit === alarm['client_id'] &&
                                                        <div className="ui input">
                                                            <Form onSubmit={() => {
                                                                this.updateAlarmDescription(alarm)
                                                            }}>
                                                                <input style={{verticalAlign: 'middle'}} type="text"
                                                                       defaultValue={alarm['ci_description']}
                                                                       placeholder="Alarm Description"
                                                                       onFocus={(e) => {
                                                                           this.setState({alarmDesc: e.target.value})
                                                                       }}
                                                                       onChange={(e) => {
                                                                           this.setState({alarmDesc: e.target.value})
                                                                       }}
                                                                       onBlur={() => {
                                                                           this.setState({showEdit: undefined});
                                                                           this.updateAlarmDescription(alarm);
                                                                       }}
                                                                       required
                                                                />
                                                            </Form>
                                                        </div>
                                                        }
                                                        {this.state.showEdit !== alarm['client_id'] &&
                                                        <span onClick={(e) => {
                                                            if (inspectionType !== 'co') {
                                                                this.setState({showEdit: alarm['client_id']});
                                                            }
                                                        }}>{alarm['ci_description'] ? alarm['ci_description'] : "NA"}</span>}
                                                    </dd>
                                                </dl>
                                            </div>
                                        </div>
                                    </Segment>
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <Segment>
                                        <Header content="Check-Out" color="teal" textAlign='center'/>
                                        <div ref={alarm['client_id']}>
                                            <Header textAlign="left">
                                                {this.state.showCoNameEdit === alarm['client_id'] &&
                                                <div className="ui input">
                                                    <Form onSubmit={() => {
                                                        this.updateAlarmName(alarm)
                                                    }}>
                                                        <input style={{verticalAlign: 'middle'}} type="text"
                                                               defaultValue={alarm['name']}
                                                               placeholder="Alarm Name"
                                                               onFocus={(e) => {
                                                                   this.setState({alarmName: e.target.value})
                                                               }}
                                                               onChange={(e) => {
                                                                   this.setState({alarmName: e.target.value})
                                                               }}
                                                               onBlur={() => {
                                                                   this.setState({showCoNameEdit: undefined});
                                                                   this.updateAlarmName(alarm);
                                                               }}
                                                               required
                                                        />
                                                    </Form>
                                                </div>
                                                }
                                                <div>
                                                    {this.state.showCoNameEdit !== alarm['client_id'] &&
                                                    <span onClick={(e) => {
                                                        if (inspectionType === 'co') {
                                                            this.setState({showCoNameEdit: alarm['client_id']});
                                                        }
                                                    }}>{alarm['name']}</span>}
                                                    {!alarm['ci_location'] && <Popup
                                                        trigger={<Icon name="trash"
                                                                       className="pull-right icon-button info-grey"/>}
                                                        content={<Button negative content="Confirm Delete?"
                                                                         onClick={() => {
                                                                             this.deleteAlarm(alarm)
                                                                         }}/>}
                                                        on="click"
                                                        position="left center"
                                                        hideOnScroll
                                                    />}
                                                </div>
                                            </Header>
                                            <Icon name="image" size="large" className="pull-right icon-button"
                                                  onClick={() => {
                                                      (inspectionType === 'co') && this.setState({coImageEdit: true})
                                                  }}/>
                                            <div>
                                                {this.state.coImageEdit &&
                                                <ImageUploadDropzone handlerFunction={(file) => {
                                                    this.updateAlarmImage(file, alarm)
                                                }}/>}
                                                <Image width="100px" height="100px"
                                                       src={alarm['co_image'] ? (alarm['co_image']['image_path'] ? alarm['co_image']['image_path'] : (alarm['co_image']['dataURL'] ? alarm['co_image']['dataURL'] : (alarm['co_image']['file'] ? alarm['co_image']['file']['dataURL'] : AlarmPlaceholder))) : AlarmPlaceholder}
                                                       centered rounded/>
                                            </div>
                                            <div>
                                                <dl>
                                                    <dt style={{minHeight: '50px'}}>Location</dt>
                                                    <dd style={{minHeight: '50px'}}>
                                                        {this.state.showCoEdit === alarm['client_id'] &&
                                                        <div className="ui input">
                                                            <Form onSubmit={() => {
                                                                this.updateAlarmLocation(alarm)
                                                            }}>
                                                                <input style={{verticalAlign: 'middle'}} type="text"
                                                                       defaultValue={alarm['co_location']}
                                                                       placeholder="Alarm Location"
                                                                       onFocus={(e) => {
                                                                           this.setState({alarmLocation: e.target.value})
                                                                       }}
                                                                       onChange={(e) => {
                                                                           this.setState({alarmLocation: e.target.value})
                                                                       }}
                                                                       onBlur={() => {
                                                                           this.setState({showCoEdit: undefined});
                                                                           this.updateAlarmLocation(alarm);
                                                                       }}
                                                                       required
                                                                />
                                                            </Form>
                                                        </div>
                                                        }
                                                        {this.state.showCoEdit !== alarm['client_id'] &&
                                                        <span onClick={(e) => {
                                                            if (inspectionType === 'co') {
                                                                this.setState({showCoEdit: alarm['client_id']});
                                                            }
                                                        }}>{alarm['co_location'] ? alarm['co_location'] : "NA"}</span>}
                                                    </dd>
                                                    <dt style={{ minHeight: '50px' }}>Expiry Date</dt>
                                                    <dd style={{minHeight: '50px'}}>
                                                        {this.state.showCoEdit === alarm['client_id'] &&
                                                        <div className="ui input">
                                                            <Form onSubmit={() => {
                                                                this.updateAlarmExpiry(alarm)
                                                            }}>
                                                                <input style={{verticalAlign: 'middle'}} type="text"
                                                                       defaultValue={alarm['co_expiry']}
                                                                       placeholder="Alarm Expiry Date"
                                                                       onFocus={(e) => {
                                                                           this.setState({alarmExpiry: e.target.value})
                                                                       }}
                                                                       onChange={(e) => {
                                                                           this.setState({alarmExpiry: e.target.value})
                                                                       }}
                                                                       onBlur={() => {
                                                                           this.setState({showCoEdit: undefined});
                                                                           this.updateAlarmExpiry(alarm);
                                                                       }}
                                                                       required
                                                                />
                                                            </Form>
                                                        </div>
                                                        }
                                                        {this.state.showCoEdit !== alarm['client_id'] &&
                                                        <span onClick={(e) => {
                                                            if (inspectionType == 'co') {
                                                                this.setState({showCoEdit: alarm['client_id']});
                                                            }
                                                        }}>{alarm['co_expiry'] ? alarm['co_expiry'] : "Not Seen"}</span>}
                                                    </dd>
                                                    <dt style={{minHeight: '75px'}}>Description</dt>
                                                    <dd style={{minHeight: '75px'}} className="alarm-description">
                                                        {this.state.showCoEdit === alarm['client_id'] &&
                                                        <div className="ui input">
                                                            <Form onSubmit={() => {
                                                                this.updateAlarmDescription(alarm)
                                                            }}>
                                                                <input style={{verticalAlign: 'middle'}} type="text"
                                                                       defaultValue={alarm['co_description']}
                                                                       placeholder="Alarm Description"
                                                                       onFocus={(e) => {
                                                                           this.setState({alarmDesc: e.target.value})
                                                                       }}
                                                                       onChange={(e) => {
                                                                           this.setState({alarmDesc: e.target.value})
                                                                       }}
                                                                       onBlur={() => {
                                                                           this.setState({showCoEdit: undefined});
                                                                           this.updateAlarmDescription(alarm);
                                                                       }}
                                                                       required
                                                                />
                                                            </Form>
                                                        </div>
                                                        }
                                                        {this.state.showCoEdit !== alarm['client_id'] &&
                                                        <span onClick={(e) => {
                                                            if (inspectionType === 'co') {
                                                                this.setState({showCoEdit: alarm['client_id']});
                                                            }
                                                        }}>{alarm['co_description'] ? alarm['co_description'] : "NA"}</span>}
                                                    </dd>
                                                </dl>
                                            </div>
                                        </div>
                                    </Segment>
                                </Grid.Column>
                            </Grid>)
                        }) : null}

                    </Modal.Description>
                    <AddNewAlarm key={reportAlarms? reportAlarms.length : -1}/>
                </Modal.Content>
            </Modal>
        </Segment>);
    }
}

export default ReportContainer(Alarms);


// WEBPACK FOOTER //
// ./src/views/report/alarms.js